// Back-end address, used by Apollo (index.js) and by the exam screen's live
// "questions updated" stream. Switch servers here.

// export const GRAPHQL_URI = process.env.REACT_APP_API_URL;
export const GRAPHQL_URI = "https://api.rizee.in/graphql";
// export const GRAPHQL_URI = "https://rizee-student-backend-755214126997.us-south1.run.app/graphql";
// export const GRAPHQL_URI = "http://localhost:4005/graphql";

// Same server without the /graphql path, for plain HTTP endpoints.
export const API_BASE_URL = GRAPHQL_URI.replace(/\/graphql\/?$/, "");
